
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Punetogoainnovacabbooking() {



    const cardData =
    {
        keyword: 'Pune to Goa Innova Cab Booking',
        heading: 'S9 Travels: Pune to Goa Innova Cab Booking',
        headingDescription: 'S9 Travels offers premium Innova cab services for travelers going from Pune to Goa. Whether you are heading to the beautiful beaches of Goa, planning a family vacation, or traveling for business, our fleet of well-maintained Innovas provides a safe, reliable, and luxurious travel experience. The distance between Pune and Goa is approximately 450 km, and the journey typically takes around 8 to 9 hours by road. With S9 Travels, enjoy a smooth, comfortable, and hassle-free ride to one of India’s most popular holiday destinations.',

        top: 'Top Places to Visit in Goa with S9 Travels',

"topPlaces": [
    {
      "title": "Baga Beach",
      "description": "Baga Beach is one of Goa's most popular beaches, known for its lively atmosphere, water sports, and beach shacks offering delicious food and drinks. It’s an ideal spot for both relaxation and excitement, especially during the evenings when the beach comes alive with music and parties."
    },
    {
      "title": "Calangute Beach",
      "description": "Calangute Beach is one of the largest and most popular beaches in Goa. It is perfect for a relaxing day by the sea, offering sunbathing, water sports, and a variety of beachside activities. The beach is lined with restaurants and shops, making it an excellent place for both tourists and locals."
    },
    {
      "title": "Fort Aguada",
      "description": "Fort Aguada, a 17th-century Portuguese fort located at the mouth of the Mandovi River, offers stunning views of the Arabian Sea. The fort also houses a lighthouse, which is one of the oldest in Asia. The fort's well-preserved structure and scenic surroundings make it a popular historical attraction."
    },
    {
      "title": "Dudhsagar Waterfalls",
      "description": "Dudhsagar Waterfalls, located on the border between Goa and Karnataka, is one of the tallest waterfalls in India. The waterfall, surrounded by lush greenery, creates a breathtaking sight, especially during the monsoon season. It’s an excellent spot for nature lovers and adventure seekers, offering hiking opportunities and jeep safaris."
    },
    {
      "title": "Basilica of Bom Jesus",
      "description": "The Basilica of Bom Jesus, a UNESCO World Heritage Site, is one of the most significant and historic churches in Goa. It is famous for housing the mortal remains of St. Francis Xavier. The church's stunning baroque architecture and religious importance make it a must-visit destination for history buffs and spiritual travelers."
    },
    {
      "title": "Anjuna Beach",
      "description": "Anjuna Beach, famous for its vibrant nightlife, trance parties, and beautiful sunsets, is one of the most famous beaches in North Goa. The beach also features rocky patches and is known for its flea market, where visitors can shop for local handicrafts, clothing, and souvenirs."
    },
    {
      "title": "Chapora Fort",
      "description": "Chapora Fort, known for its scenic views and historic significance, offers panoramic views of Vagator Beach and the Arabian Sea. The fort gained fame after being featured in the Bollywood movie Dil Chahta Hai and is a popular spot for photography and picnics."
    },
    {
      "title": "Se Cathedral",
      "description": "The Se Cathedral is one of the largest churches in Asia and is an excellent example of Portuguese-Gothic architecture. It is dedicated to St. Catherine and is known for its grandeur and the famous Golden Bell. It’s one of the oldest churches in Goa, with rich historical and cultural significance."
    },
    {
      "title": "Palolem Beach",
      "description": "Palolem Beach, located in South Goa, is known for its serene beauty, clear waters, and relaxed atmosphere. This crescent-shaped beach is perfect for swimming, sunbathing, and kayaking. The calm vibe makes it an excellent choice for those looking to unwind and enjoy the natural beauty of Goa."
    },
    {
      "title": "Salim Ali Bird Sanctuary",
      "description": "Located on the island of Chorao, the Salim Ali Bird Sanctuary is a haven for birdwatchers and nature lovers. It is home to various species of migratory and resident birds, along with a rich ecosystem of mangroves and mudflats. Visitors can enjoy peaceful walks through the sanctuary and take boat rides to spot wildlife."
    }
],

"services": [
    {
      "name": "Pune to Goa Innova Taxi Service",
      "description": "Make your journey from Pune to Goa comfortable and enjoyable with our Innova taxi service. Whether it's a one-way trip, round trip, or a group travel plan, we offer the perfect vehicle to cater to your travel needs."
    },
    {
      "name": "Book Pune to Goa Innova Cab Service",
      "description": "Booking an Innova cab for your trip from Pune to Goa is easy and convenient. Our reliable and well-maintained vehicles ensure that you reach your destination in comfort and style, whether for business or leisure."
    },
    {
      "name": "Pune to Goa Innova Car Rental",
      "description": "Rent an Innova for your trip to Goa and enjoy the flexibility of a private vehicle. Our rental service offers competitive pricing and reliable vehicles for both short and long trips, ensuring a smooth ride all the way to Goa."
    },
    {
      "name": "Pune to Goa One-Way Innova",
      "description": "Traveling one-way from Pune to Goa? Our one-way Innova taxi service is the perfect option for a hassle-free journey. With spacious interiors and comfortable seating, you'll have a smooth ride from start to finish."
    },
    {
      "name": "Pune to Goa Round Trip Innova",
      "description": "For those planning a round trip to Goa, our round-trip Innova taxi service offers convenience and flexibility. You can customize your travel dates, and our professional drivers will ensure you have a comfortable and safe trip."
    },
    {
      "name": "Pune to Goa Luxury Innova Cab",
      "description": "Experience luxury travel with our premium Innova cabs. Whether you're traveling for leisure or business, our luxury Innova cabs offer a high level of comfort with plush interiors and high-end features, making your journey to Goa special."
    },
    {
      "name": "Affordable Pune to Goa Innova Service",
      "description": "Our Pune to Goa Innova taxi service is designed to be budget-friendly without compromising on comfort. We offer affordable rates for both one-way and round-trip bookings, ensuring you get the best value for your money."
    },
    {
      "name": "Goa Trip by Innova from Pune",
      "description": "Looking to explore Goa? Book an Innova for a comfortable sightseeing trip. Visit popular attractions in Goa like the beautiful beaches, churches, and markets, all while traveling in comfort and style."
    },
    {
      "name": "Group Travel to Goa in Innova",
      "description": "If you're traveling with family or a group of friends, our Innova cabs are the perfect choice. With ample seating capacity for up to 7 passengers, it’s a great way to travel together and share the experience of Goa."
    },
    {
      "name": "Private Innova for Goa Tour",
      "description": "For a personalized travel experience, book a private Innova for your Goa tour. Whether you want to visit iconic beaches, historical sites, or hidden gems, your private cab will be at your service to ensure maximum comfort and convenience."
    },
    {
      "name": "Book Innova for Goa Travel",
      "description": "Secure your Innova cab for your next Goa trip. Whether you're heading for a holiday or a business trip, our Innova cabs offer a perfect combination of comfort and luxury, ensuring your journey is relaxing and pleasant."
    },
    {
      "name": "Goa Innova Car Hire",
      "description": "Hire an Innova for your Goa trip and enjoy the flexibility of having your own vehicle. Whether for a short trip or a long stay, our Innova hire service ensures that you have the freedom to explore Goa at your own pace."
    },
    {
      "name": "Book Goa Trip Innova",
      "description": "For your next Goa trip, make your journey stress-free by booking an Innova cab. With spacious seating and air-conditioning, you'll enjoy a comfortable and enjoyable ride all the way to Goa."
    },
    {
      "name": "Pune to Goa Private Cab",
      "description": "For a private and exclusive travel experience, book a private Innova cab for your journey from Pune to Goa. Our experienced drivers will ensure that you travel in comfort and style, without the hassle of public transport."
    },
    {
      "name": "Goa Sightseeing Innova",
      "description": "Explore Goa in the comfort of an Innova. Book our sightseeing Innova service and visit Goa's top attractions, from its beaches and forts to the churches and vibrant markets. Our drivers can guide you to the best spots in Goa while ensuring a comfortable experience."
    }
  ],

"tableData": [
  ["Book Pune to Goa Innova Taxi", "Pune to Goa Innova Cab Service"],
  ["Pune to Goa Innova Car Rental", "Pune to Goa One-Way Innova"],
  ["Pune to Goa Round Trip Innova", "Pune to Goa Luxury Innova Cab"],
  ["Affordable Pune to Goa Innova Service", "Goa Trip by Innova from Pune"],
  ["Group Travel to Goa in Innova", "Private Innova for Goa Tour"],
  ["Book Innova for Goa Travel", "Goa Innova Car Hire"],
  ["Book Goa Trip Innova", "Pune to Goa Private Cab"],
  ["Goa Sightseeing Innova", ""]
],
"whychoose": [
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "At S9 Travels, we value your time. Whether you're traveling to Goa for a vacation, business trip, or any special occasion, our experienced drivers ensure that you are picked up from Pune on time and reach your destination in Goa safely and promptly."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles",
    "WhyChoosedescription": "Our Toyota Innova cabs are ideal for long-distance travel, offering spacious seating, air conditioning, and a smooth ride. Whether you're traveling with family, friends, or colleagues, the Innova ensures a comfortable and relaxing journey from Pune to Goa."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are highly experienced in long-distance travel, especially on the Pune to Goa route. They are courteous, professional, and well-versed in the best routes to ensure you have a safe and smooth journey. With their expert navigation skills, you can sit back and enjoy the ride."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers competitive pricing for your Pune to Goa Innova ride. There are no hidden charges, and we provide a clear breakdown of the cost so you know exactly what you're paying for. Our goal is to offer you value for money without compromising on service quality."
  },
  {
    "WhyChooseheading": "Safe and Comfortable Journey",
    "WhyChoosedescription": "Your safety is our top priority. Our Toyota Innova cars are equipped with modern safety features such as airbags, seat belts, and GPS tracking. You can travel with peace of mind, knowing that we prioritize your safety on every trip."
  },
  {
    "WhyChooseheading": "24/7 Availability",
    "WhyChoosedescription": "S9 Travels is available round-the-clock for your convenience. Whether you're planning an early morning trip or a late-night return from Goa, we are always ready to accommodate your needs. Our customer service team is also available to assist with any last-minute bookings or adjustments."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Booking your Pune to Goa Innova cab is simple and quick. You can book online through our website or mobile app, or you can contact our customer service team for personalized assistance. We make sure the process is hassle-free, so you can focus on enjoying your trip."
  },
  {
    "WhyChooseheading": "Customized Travel Packages",
    "WhyChoosedescription": "We understand that each traveler has different needs. Whether you're going to Goa for sightseeing, a leisure vacation, or a business trip, we offer customized travel packages. Let us know your preferences, and we'll tailor the trip to your exact requirements, ensuring a personalized experience."
  }
]
























    }



    const faqData = [
        [
          {
            question: 'How can I book an Innova for Pune to Goa?',
            answer: 'You can book your Innova cab easily via our website, mobile app, or by contacting our customer service team for any assistance.',
          },
          {
            question: 'What is the seating capacity of the Innova?',
            answer: 'The Toyota Innova accommodates up to 6 passengers comfortably, making it perfect for families, groups of friends, or business travel.',
          },
          {
            question: 'Are the drivers experienced for long-distance travel from Pune to Goa?',
            answer: 'Yes, our drivers are experienced in handling long-distance journeys and are familiar with the Pune to Goa route. They ensure a smooth, safe, and comfortable ride throughout the trip.',
          },
          {
            question: 'What payment options are available for booking the Innova?',
            answer: 'We offer multiple payment options including cash, credit/debit cards, and online payment through our app, making the payment process convenient for you.',
          },
          {
            question: 'Can I book a round trip from Pune to Goa?',
            answer: 'Yes, we can arrange round-trip bookings. Just provide your return details, and we’ll ensure your trip to and from Goa is comfortable and hassle-free.',
          },
          {
            question: 'Are there any extra charges for waiting or detours?',
            answer: 'Any extra charges for waiting time or detours will be clearly communicated to you upfront. We believe in transparency and want to avoid any surprises during your trip.',
          },
          {
            question: 'Can I make extra stops during my trip to Goa?',
            answer: 'Yes, if you would like to make additional stops along the way to Goa, let us know during the booking process, and we will make the necessary arrangements.',
          },
          {
            question: 'What is the luggage allowance for the Innova cab?',
            answer: 'The Toyota Innova has ample space for standard luggage. If you have more luggage or special requirements, please let us know at the time of booking, and we’ll ensure your needs are accommodated.',
          },
          {
            question: 'Is S9 Travels available for corporate travel to Goa?',
            answer: 'Yes, we provide corporate travel services for groups, employees, or business-related trips to Goa. We ensure comfort, reliability, and professionalism for all corporate journeys.',
          },
          {
            question: 'Why should I choose S9 Travels for my Pune to Goa Innova ride?',
            answer: 'S9 Travels offers reliable, safe, and comfortable transport for your journey from Pune to Goa. With professional drivers, well-maintained vehicles, and transparent pricing, we guarantee a smooth and enjoyable trip.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Abhishek Joshi',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“Our trip from Pune to Goa was amazing! The Innova was spacious, and the driver was friendly and professional. The ride was smooth and comfortable, and we arrived in Goa on time. Highly recommend S9 Travels for any long-distance trips!”',
        },
        {
          name: 'Mrs. Neha Soni',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“We had a fantastic experience with S9 Travels. The Innova was well-maintained, and the driver made our journey from Pune to Goa enjoyable and hassle-free. We will definitely book with them again for our next trip!”',
        },
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune to Goa Innova Cab Booking",
        "description": "Book an Innova cab from Pune to Goa for a luxurious and comfortable journey. Offering one-way, round-trip, and group bookings for your Goa tour, sightseeing, and relaxation.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "890"
        }
      };
      
     
      
      


    return (
        <div>
          <Helmet>
        <title>Pune to Goa Innova Cab Booking | Luxury & Affordable Taxi Service</title>
        <meta 
          name="description" 
          content="Book an Innova taxi from Pune to Goa for a smooth and enjoyable journey. One-way, round-trip, group travel, and luxury options available for Goa sightseeing, family trips, and private tours." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
      
      
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/101.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetogoainnovacabbooking;